import React from 'react';
import { motion } from 'framer-motion';

const Privacy = () => {
  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="privacy-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <span className="text-sm uppercase tracking-[0.2em] text-[var(--color-primary)] font-medium">
            Legal
          </span>
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tighter text-[var(--text-primary)] mt-4 mb-4">
            Privacy Policy
          </h1>
          <p className="text-[var(--text-secondary)] mb-8">
            Last updated: January 15, 2026
          </p>

          <div className="space-y-8 text-[var(--text-secondary)]">
            <section>
              <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">1. Introduction</h2>
              <p>
                DeFi Bot ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">2. Information We Collect</h2>
              <p className="mb-4">We collect information that you provide directly to us:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Wallet Address:</strong> Your public blockchain address for Service access</li>
                <li><strong>Contact Information:</strong> Email address for notifications and support</li>
                <li><strong>Transaction Data:</strong> Records of trades executed through our Service</li>
                <li><strong>Usage Data:</strong> How you interact with our Service</li>
              </ul>
              <p className="mt-4">
                <strong>Important:</strong> We never collect or store your private keys, seed phrases, or passwords.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">3. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Provide, maintain, and improve our Service</li>
                <li>Process transactions and send related information</li>
                <li>Send technical notices and support messages</li>
                <li>Respond to your comments and questions</li>
                <li>Analyze usage patterns to improve user experience</li>
                <li>Detect and prevent fraudulent activities</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">4. Data Sharing and Disclosure</h2>
              <p>We do not sell your personal information. We may share information:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>With service providers who assist in our operations</li>
                <li>To comply with legal obligations</li>
                <li>To protect our rights and the rights of others</li>
                <li>In connection with a merger or acquisition</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">5. Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">6. Data Retention</h2>
              <p>
                We retain your personal information for as long as necessary to provide our Service and fulfill the purposes outlined in this Privacy Policy. Transaction records are retained for a minimum of 7 years for regulatory compliance.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">7. Your Rights</h2>
              <p>Depending on your location, you may have the right to:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Object to processing of your data</li>
                <li>Request data portability</li>
              </ul>
              <p className="mt-4">
                To exercise these rights, contact us at privacy@defi-bot.io
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">8. Cookies and Tracking</h2>
              <p>
                We use cookies and similar tracking technologies to track activity on our Service and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">9. International Transfers</h2>
              <p>
                Your information may be transferred to and processed in countries other than your country of residence. We ensure appropriate safeguards are in place to protect your information.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">10. Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy, please contact us:
              </p>
              <p className="mt-2">
                Email: privacy@defi-bot.io<br />
                Address: 71-75 Shelton Street, Covent Garden, London WC2H 9JQ, United Kingdom
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Privacy;
